import React from 'react';

const LeaderboardCellPos = ({ data }) => {
    const position = (data.position && data.position.displayValue) || '-';

    return (
        <div className="leaderboard__cell leaderboard__cell--pos">
            <div className="leaderboard__cell-content">{position}</div>
        </div>
    );
};

export default LeaderboardCellPos;
